import HTML from './view-cover-letter.html';
import RfpPreloadController from '../rfp-preload.ctrl';

export { HTML, RfpPreloadController as Controller }
